import { buildEntryFetchParams } from './entries'


const ENTRY_QUERY_PARAM_KEYS = [ 'filterKey', 'query', 'expression', 'sortKey', 'sortDirection' ]

export const buildExportConditionsFromEntryIdList = (entryIdList) => {
  if (!entryIdList.every((entryId) => (typeof entryId == 'number'))) {
    throw new Error('EntryIds expected to be an array of integers')
  }

  const entryConditions = entryIdList.map( (entryId) => ({
    key: 'id',
    op: '==',
    value: `${entryId}`, compareToNone: false
  }))

  return {
    conditionsArray: [],
    expression: {
      conditions: entryConditions,
      operator: 'or'
    },
    sortKey: null,
    sortDirection: null
  }
}

export const buildExportConditionsFromEntryIdListWithSort = (spec) => {
  const { entryIds, sortKey, sortDirection, query } = spec
  const baseConditions = buildExportConditionsFromEntryIdList(entryIds)

  return {
    ...baseConditions,
    sortKey,
    sortDirection,
    ...(query ? { search: query } : {})
  }
}

export const buildExportConditionsFromEntryQueryParams = (queryParams) => {
  if (!ENTRY_QUERY_PARAM_KEYS.every((k) => (k in queryParams))) {
    throw new Error('Invalid entry query spec')
  }
  const {
    filterKey,
    query,
    expression,
    sortKey,
    sortDirection
  } = queryParams

  const entryFetchParams = buildEntryFetchParams(filterKey, expression, query)

  return {
    conditionsArray: entryFetchParams.conditions,
    expression: entryFetchParams.expression,
    sortKey,
    sortDirection,
    ...(entryFetchParams.search ? { search: entryFetchParams.search } : {})
  }
}

export const buildEntriesExportsConditionsSpec = (spec) => {
  // Check if it's an object with entryIds (individual selection with sort)
  if (spec && typeof spec === 'object' && !Array.isArray(spec) && spec.entryIds) {
    return buildExportConditionsFromEntryIdListWithSort(spec)
  }
  // Check if it's a plain array (individual selection without sort - legacy)
  if (Array.isArray(spec)) {
    return buildExportConditionsFromEntryIdList(spec)
  }
  // Otherwise it's query params (conditional filtering)
  return buildExportConditionsFromEntryQueryParams(spec)
}